export default __webpack_public_path__ + "static/media/bg5.396976e4.webp";